<template>
    <div class="layout-container">
        
        <!-- Contenido principal -->
        <div class="main-content">
            <div class="card">
                <form @submit.prevent="handleSubmit(!v$.$invalid)">
                    <div class="grid-container form-container" style="margin-top: 40px;">
                          <div class="field-content" v-for="(field, fieldIndex) in fields" :key="field.id" :style="{ gridRow: field.row, gridColumn: `${field.column} / span ${field.size}`}" >                     
                              <div v-if="field.idGroup">
                                <span class="p-float-label" style="font-weight: bold;" v-if="field.typeGroup === 'Checkbox'">     
                                   <label :for="field.name" style="margin-left: 20px;">{{ field.label }}</label>                
                                   <Checkbox
                                        :id="field.name" 
                                        :tabindex="fieldIndex"                                          
                                        value="true"                                                                                                    
                                        style="width: 100%;"
                                        v-model="v$.data[field.name].$model"   
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"  
                                    />
                                </span> 
                                <span class="p-float-label" style="font-weight: bold;" v-if="field.typeGroup === 'Radio'">     
                                   <label :for="field.name" style="margin-left: 20px;">{{ field.name }}</label>                      
                                   <RadioButton
                                        :id="field.name" 
                                        :name="field.idGroup" 
                                        :tabindex="fieldIndex"                                          
                                        :value="field.name"                                                                                                    
                                        style="width: 100%; min-width: 100px;"
                                        v-model="v$.data[field.name].$model"   
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"  
                                    />
                                </span> 
                                <span class="p-float-label" style="font-weight: bold;" v-if="field.typeGroup === 'List' && field.visible">     
                                  <Dropdown    
                                        :id="field.name"  
                                        :tabindex="fieldIndex+1"
                                        :options="JSON.parse(field.options)"
                                        optionLabel="name"
                                        optionValue="value"
                                        style="width: 100%;"
                                        v-model="v$.data[field.name].$model" 
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"                                 
                                    />     
                                    <Label :field="field" />       
                                </span> 
                              </div>      
                              <div v-else>
                                <span class="p-float-label" style="font-weight: bold;" v-if="field.type === 'String'">                    
                                    <InputText
                                        :id="field.name"                                           
                                        :tabindex="fieldIndex+1"
                                        type="text"
                                        style="width: 100%;"
                                        v-model="v$.data[field.name].$model" 
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"  
                                    />
                                    <Label :field="field" />     
                  
                                </span> 
                                <span class="p-float-label" style="font-weight: bold;" v-if="field.type === 'Number'">                    
                                    <InputText
                                        :id="field.name"                                           
                                        :tabindex="fieldIndex+1"
                                        type="number"
                                        style="width: 100%;"
                                        v-model="v$.data[field.name].$model" 
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"  
                                    />
                                    <Label :field="field" />
                                </span> 
                                <span class="p-float-label" style="font-weight: bold;" v-if="field.type === 'Date'">                    
                                    <Calendar
                                        :id="field.name"   
                                        :tabindex="fieldIndex+1"
                                        v-model="v$.data[field.name].$model" 
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"  
                                    />
                                    <Label :field="field" />
                                </span>     
                                <span class="p-label" style="font-weight: bold" v-if="field.type === 'Boolean'">   
                                    <label :for="field.name" style="margin-right: 10px;">{{ field.label }}</label>                 
                                    <InputSwitch
                                        :id="field.name" 
                                        :tabindex="fieldIndex"  
                                        v-model="v$.data[field.name].$model" 
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }" 
                                        
                                    />                    
                                </span>   
                                <span class="p-float-label" style="font-weight: bold" v-if="field.type === 'List'">       
                                
                                    <Dropdown    
                                        :id="field.name"  
                                        :tabindex="fieldIndex+1"
                                        :options="JSON.parse(field.options)"
                                        optionLabel="name"
                                        optionValue="value"
                                        style="width: 100%;"
                                        v-model="v$.data[field.name].$model" 
                                        @focus="handleFieldFocus($event, field)"
                                        @blur="handleFieldBlur($event, field)"
                                        :class="{ 'p-invalid': v$.data[field.name].$invalid && submitted }"                                 
                                    />     
                                    <Label :field="field" />                              
                                </span>  

                                <div v-if="field.type === 'Label'" style="cursor: pointer;">
                                    <h3 v-if="!field.isEditing">{{ field.label }}</h3>           
                                </div>

                                <div v-if="field.type === 'Image'"> 
                                  <img :src="field.options" alt="Image" style="width: 100%; height: 100%; object-fit: cover;"/>
                                </div>
                            
                                <div v-if="this.isInput(field)">
                                    <small v-if="(v$.data[field.name].$invalid && submitted) || v$.data[field.name].$pending.$response" class="p-error">
                                         <div v-for="error of v$.data[field.name].$errors" :key="error.$uid">
                                        {{ error.$message }}
                                        </div>
                                    </small> 
                                </div>
                            </div>  
                        </div>
                  </div>

                  <div class="p-d-flex p-jc-center p-mt-4">                    
                      <div class="p-mt-4"><Button type="submit" label="Enviar"/></div>
                  </div>
            </form>
        </div>
      </div>
    
    </div>
</template>  

<script>

import { apiGet, apiPost } from '../../helpers/rest-api'
import useVuelidate from '@vuelidate/core';
import { generarReglasDesdeJSON } from '../../helpers/validations'; 

import DROP_POSITION from '../../enum/FormDesign';


import Label from './Label.vue';

const reglasJSON = [
        {
          field: 'NOMBREAPELLIDO',
          rules: [{ type: 'required', message: 'Campo obligatorio' }]
        },{
            field: 'CIF',       
            rules: [
                { type: 'required', message: 'Campo obligatorio' },
                { type: 'minValue', value: 11, message: 'El valor debe ser mayor a :minValue' },
                { type: 'maxValue', value: 100, message: 'El valor debe ser menor a :maxValue' },
            ]
        },
        {
          field: 'PAIS',          
          rules: [
                {
                    type: 'requiredIfAll', // 👈 clave aquí
                    conditions: [
                    { field: 'NOMBREAPELLIDO', operator: '==', value: 'A' },
                    { field: 'CIF', operator: '>', value: 18 }
                    ],
                    message: ':property es obligatorio si NOMBREAPELLIDO es A o CIF > 18'
                }
            ]
        },
        {
          field: 'ESTADOCIVIL',          
          rules: [
                {
                    type: 'requiredIf', // 👈 clave aquí
                    field: 'NOMBREAPELLIDO', 
                    operator: '==', 
                    value: 'A' ,
                    message: ':property es obligatorio si NOMBREAPELLIDO es A'
                }
            ]
        }
      ]

export default {
    components: {
        Label,      
        
    },
    setup() {

    },
    data () {
        return { 
                v$: null,
                fields : [], 
                data: {}, 
                submitted: false,
                procesoItem: null,
                dropZoneState: {},
                // Propiedades para resize
                isResizing: false,
                resizingField: null,
                startX: 0,
                startSize: 0,
                // Propiedades para información de campo
                fieldInfo: {
                    visible: false,
                    text: '',
                    x: 0,
                    y: 0
                },
                // Propiedades para drop zones
                dropZones: [],
                dropZoneTimer: null,
                // Propiedades para línea de inserción
                showInsertLine: true,
                insertLinePosition: 0,  
                DROP_POSITION,
                // Propiedad para tracking de drag over en filas vacías
                emptyRowDragOver: null,
                // Propiedad para modo debug
                debugMode: true
            }
        },
        mounted () {
          console.log('getProcess', this.$route);
            this.getProcess()       
        },    
        methods: {           
            async getProcess() {
           
            const res = await apiGet(`procesoitem/${this.$route.params.id}`)
            this.procesoItem = res.data
            await this.getAll()           
        }, 
        async getAll() {
            const { proceso } = this.procesoItem
            const { plantilla } = proceso;

            if (!plantilla ||  !plantilla.id) {
                console.error('No se encontró el ID de la plantilla')
                return
            }
            const res = await apiGet(`field/plantilla/${plantilla.id}`)

            this.fields = this.widthToSize(res.data);    
           
             // Inicializamos los datos
            this.data = this.fields.reduce((acc, field) => {
                acc[field.name] = field.type === 'Boolean' ? false : ''
                return acc
            }, {})

            // ⚠ Generás reglas dinámicamente
            const rules = {
                data: generarReglasDesdeJSON(this.fields, reglasJSON, this)
            }
            // ⚠ Ahora sí, inicializás Vuelidate manualmente
            this.v$ = useVuelidate(rules, this)
        },  

        // Handle Submit
        handleSubmit(isFormValid) {
            
            this.submitted = true;
            this.v$.$touch()

            if (!isFormValid) {
                console.warn('Formulario no valido');
                return;
            }

            const fields = this.fields.map((field) => {
                const value = field.type === 'Date' ? this.data[field.name].toISOString() : String(this.data[field.name]);
                return {...field, value: value}
            });

            apiPost(`form/${this.procesoItem.id}/true`, JSON.stringify(fields)).then((data) => console.log(data));
        },     
        handleFieldFocus(event) {
            // Cambiar el color de fondo del campo cuando toma el foco
            event.target.style.backgroundColor = '#e3f2fd';
            event.target.style.borderColor = '#2196f3';
            
            // También cambiar el color del label
            const label = event.target.parentElement.querySelector('label');
            if (label) {
                label.style.color = '#2196f3';
            }
            
           // console.log('Campo enfocado:', field.name);
        },
        handleFieldBlur(event) {
            // Restaurar el color de fondo cuando pierde el foco
            event.target.style.backgroundColor = '';
            event.target.style.borderColor = '';
            
            // Restaurar el color del label
            const label = event.target.parentElement.querySelector('label');
            if (label) {
                label.style.color = '';
            }
            
           // console.log('Campo perdió el foco:', field.name);
        },

        // Width to Size
        widthToSize(fields) {
            const WIDTH_PDF_A4 = 595.28;

            return fields.map((field) => {
              if (field.size == undefined || field.size == 0) {
                const percentage = field.width * 100 / WIDTH_PDF_A4;
                const size = Math.round(percentage * 12 / 100 );
                field.size = size == 0 ? 1 : size;
              } 
              
              return field;
            });
        },

        selectField({ event, field }) {
            // Limpiar selección anterior
            if (event.shiftKey === true) {
                field.isSelected = !field.isSelected;
            } else {
              this.fields.forEach(f => f.isSelected = false);    
              field.isSelected = true;
            }
    
            // Hacer scroll al campo en el formulario
            this.$nextTick(() => {
                const fieldElement = document.querySelector(`[data-field-id="${field.id}"]`);
                if (fieldElement) {
                    fieldElement.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'center' 
                    });
                    
                    // Aplicar efecto visual de selección
                    fieldElement.style.boxShadow = '0 0 0 3px rgba(0, 123, 255, 0.5)';
                    fieldElement.style.borderColor = '#007bff';
                    
                    // Remover el efecto después de 2 segundos
                    setTimeout(() => {
                        fieldElement.style.boxShadow = '';
                        fieldElement.style.borderColor = '';
                    }, 2000);
                }
            });
            
           // console.log('Campo seleccionado:', field.name);
        },
        isInput(field) {
            return field.type !== 'Label' && field.type !== 'Image';
        },
    }
}

/**/


//

</script>


<style scoped>
/* Layout principal */
.layout-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}



/* Contenido principal */
.main-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #ffffff;
}

.p-error{
    padding-top: 5px;
    font-size: 14px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
}

.grid-item {
  /* estilos opcionales */
}

/* Estilos para transiciones suaves en los campos */
.p-float-label input,
.p-float-label .p-inputtext,
.p-float-label .p-calendar,
.p-float-label .p-dropdown,
.p-label .p-inputswitch {
  transition: all 0.3s ease;
}

.p-float-label label,
.p-label label {
  transition: color 0.3s ease;
}

/* Estilos para SectionLabel */
div[style*="cursor: pointer"] h3 {
  transition: all 0.3s ease;
  padding: 8px;
  border-radius: 4px;
  margin: 0;
}

div[style*="cursor: pointer"] h3:hover {
  background-color: #f5f5f5;
  border: 1px dashed #ccc;
}

/* Estilos para el input de edición */
div[style*="cursor: pointer"] input {
  transition: all 0.3s ease;
  outline: none;
}

div[style*="cursor: pointer"] input:focus {
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}



/* Estilos para el tooltip de información del campo 
.field-info-tooltip {
  position: fixed;
  background-color: #2c3e50;
  color: #ffffff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  max-width: 400px;
  min-width: 350px;
  font-size: 12px;
  line-height: 1.4;
  pointer-events: none;
  animation: fadeIn 0.2s ease-in-out;
  border: 1px solid #34495e;
}

.field-info-tooltip::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 10px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #2c3e50;
}

.field-info-tooltip pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: 'Courier New', monospace;
  font-size: 11px;
  color: #ecf0f1;
}

.field-info-tooltip pre .drag-drop-title {
  color: #3498db;
  font-weight: bold;
}

.field-info-tooltip pre .warning {
  color: #e74c3c;
}

.field-info-tooltip pre .success {
  color: #2ecc71;
}

.field-info-tooltip pre .info {
  color: #f39c12;
}



@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.draggable-field:hover .position-badge {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.95);
}

*/



/* Estilos para drop zones en espacios vacíos */
.drop-zone {
  min-height: 100px;
  border: 2px dashed transparent;
  border-radius: 4px;
  transition: all 0.3s ease;
  position: relative;
}

.drop-zone:hover {
  border-color: #3498db;
  background-color: rgba(52, 152, 219, 0.1);
}

.drop-zone-active {
  border-color: #2ecc71 !important;
  background-color: rgba(46, 204, 113, 0.2) !important;
  animation: pulse 1s infinite;
}

.drop-zone-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.drop-zone:hover .drop-zone-indicator,
.drop-zone-active .drop-zone-indicator {
  opacity: 1;
}

.drop-zone-text {
  font-size: 10px;
  color: #3498db;
  font-weight: 500;
  text-align: center;
  pointer-events: none;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(46, 204, 113, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(46, 204, 113, 0);
  }
}

/* Estilos para filas vacías y botón de eliminar */
.empty-row-delete {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 80px;
  background-color: rgba(231, 76, 60, 0.1);
  border: 2px dashed #e74c3c;
  border-radius: 8px;
  position: relative;
  padding: 16px;
}

.empty-row-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 500;
}

.empty-row-info i {
  font-size: 16px;
}

.empty-row-drop-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3498db;
  font-size: 14px;
  font-weight: 500;
  animation: fadeIn 0.3s ease;
}

.empty-row-drop-info i {
  font-size: 16px;
  color: #3498db;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estado de drag over para filas vacías */
.empty-row-delete.empty-row-drag-over {
  background-color: rgba(52, 152, 219, 0.2);
  border-color: #3498db;
  border-style: solid;
  transform: scale(1.02);
  transition: all 0.2s ease;
}

.empty-row-delete.empty-row-drag-over .empty-row-info {
  color: #3498db;
}

.empty-row-delete.empty-row-drag-over .empty-row-info i {
  animation: bounce 0.6s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-5px);
  }
  60% {
    transform: translateY(-3px);
  }
}

/* Estilos para la fila de eliminación */

.delete-row-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.3);
}

.delete-row-btn:hover {
  background-color: #c0392b;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.4);
}

.delete-row-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.3);
}

.delete-row-btn i {
  font-size: 14px;
}

/* Estilos para la barra de inserción */
.insert-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #3498db;
  border-radius: 2px;
  z-index: 10;
  animation: insertBarPulse 1s infinite;
}

.insert-bar-left {
  left: 0;
}

.insert-bar-right {
  right: 0;
}

@keyframes insertBarPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(52, 152, 219, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0);
  }
}

/* Estilos para la línea de inserción */
.insert-line {    
  width: 100%;
  height: 3px;
  background-color: #db3434;
  z-index: 1000;
  pointer-events: none;
  animation: insertLinePulse 1s infinite;
}

@keyframes insertLinePulse {
  0% {
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(52, 152, 219, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0);
  }
}

/* Estilos para controles de fila */
.row-controls {
  position: relative;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(52, 152, 219, 0.1);
  border: 1px dashed #3498db;
  border-radius: 4px;
  margin: 4px 0;
  transition: all 0.3s ease;
}

.row-controls:hover {
  background-color: rgba(52, 152, 219, 0.2);
  border-color: #2980b9;
}

.row-controls-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
}

.row-control-btn {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
}

.add-row-btn {
  background-color: #27ae60;
  color: white;
}

.add-row-btn:hover {
  background-color: #229954;
  transform: scale(1.1);
}

.remove-row-btn {
  background-color: #e74c3c;
  color: white;
}

.remove-row-btn:hover {
  background-color: #c0392b;
  transform: scale(1.1);
}

.row-number {
  font-size: 12px;
  font-weight: 500;
  color: #3498db;
  background-color: rgba(52, 152, 219, 0.1);
  padding: 2px 6px;
  border-radius: 3px;
}

.field-content {
  width: 100%;
  position: relative;  
}



</style>



<!--
 :{
                NOMBREAPELLIDO: {
                    required
                },
                PAIS: {},
                CEA: {},
                CIF: {},
                CONFIRMA: {},
                FECHA: {},
                LUGAR: {},
               
            }

            order: ${field.order}, 

            gridColumn: `${field.column} / span ${field.size}`,

-->